export default "//static.tradera.net/touchweb/static/output/images/apple-pay.3451619b.svg";